import {Button, UnifonTheme} from '@phonectas/unifon-ui-kit';
import sc from 'styled-components';

export const StyledReportErrorBtn = sc(Button)<{theme: UnifonTheme}>`
	${({theme}) => `
		background-color: ${theme.palette.white};
		padding: 5px;
        transition: background-color 0.3s ease, color 0.3s ease;
        &:hover {
            background-color: ${theme.palette.error};
            & ${StyledText} {
                color: ${theme.palette.white};
            }
        }
	`}
`;

export const StyledText = sc.span<{theme: UnifonTheme}>`
	${({theme}) => `
		color: ${theme.palette.error};
        transition: color 0.3s ease;
	`}
`;
